import { render, staticRenderFns } from "./PlayerTimer.vue?vue&type=template&id=36a511a8&"
import script from "./PlayerTimer.vue?vue&type=script&lang=ts&"
export * from "./PlayerTimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports